import React from "react";

// This component now relies on the 'speaking-bar' class from your global CSS.
export default function SpeakingWave() {
  const barHeights = [60, 80, 100, 80, 60];

  return (
    <div className="flex gap-4 justify-center items-end h-[100px]">
      {barHeights.map((h, i) => (
        <div
          key={h}
          className="speaking-bar bg-[#1B5C29]"
          style={{
            '--bar-height': `${h}px`,
            '--bar-delay': `${i * 0.2}s`,
          }}
        />
      ))}
    </div>
  );
}
